import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

// 引入组件
import Introduction from '../introduction/';
import FrameWork from '../framework/';
import SendWord from '../sendWord/';
// import ShortVideo from '../shortVideo/';
import Chip from 'Chip';

class AboutUs extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { intro, frameWork, sendword, shortVideo } = content;

        return (
            <div className={styles.aboutUs}>
                <Chip id="10153" type="static" title="研究院简介" groupName="财经研究院关于我们" content={intro}>
                    <Introduction />
                </Chip>
                <Chip id="10154" type="static" title="组织架构" groupName="财经研究院关于我们" content={frameWork}>
                    <FrameWork />
                </Chip>
                <Chip id="10155" type="static" title="嘉宾寄语" groupName="财经研究院关于我们" content={sendword}>
                    <SendWord />
                </Chip>
                {/* <ShortVideo content={shortVideo} /> */}
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
AboutUs.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
AboutUs.defaultProps = {};

export default AboutUs;
